import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function initHoverReveal() {
  const sections = document.querySelectorAll(".rg__column");
  sections.forEach((section) => {
    // get elements for animation
    const imageBlock = section.querySelector(".rg__image");
    const image = section.querySelector(".rg__image img");
    const mask = section.querySelector(".rg__image--mask");
    const text = section.querySelector(".rg__text");
    const textCopy = section.querySelector(".rg__text--copy");
    const textMask = section.querySelector(".rg__text--mask");
    const textP = section.querySelector(".rg__text--copy p");
    // const cursor = document.querySelector(".ball");
    const elems = [
      imageBlock,
      image,
      mask,
      text,
      textCopy,
      textMask,
      textP,
      // cursor,
    ];

    // reset the intial position
    gsap.set([imageBlock, textMask], { yPercent: -101 });
    gsap.set([mask, textP], { yPercent: 100 });
    gsap.set(image, { scale: 1.2 });

    // add event listeners to each section
    section.addEventListener("mouseenter", (e) =>
      createHoverReveal(e, ...elems)
    );
    section.addEventListener("mouseleave", (e) =>
      createHoverReveal(e, ...elems)
    );
  });
}

function createHoverReveal(
  e,
  imageBlock,
  image,
  mask,
  text,
  textCopy,
  textMask,
  textP
  // cursor
) {
  let tl = gsap.timeline({
    defaults: {
      duration: 1,
      ease: "power4.out",
    },
  });

  if (e.type === "mouseenter") {
    tl.to([mask, imageBlock, textMask, textP], {
      yPercent: 0,
    })
      .to(
        text,
        {
          y: () => -getTextHeight(textCopy) / 2,
          color: "var(--text-light)",
        },
        0
      )
      .to(image, { duration: 1.1, scale: 1 }, 0);
    // .to(cursor, { duration: 0.3, borderColor: "white" }, 0);
  } else if (e.type === "mouseleave") {
    tl.to([mask, textP], { yPercent: 100 })
      .to([imageBlock, textMask], { yPercent: -101 }, 0)
      .to(text, { y: 0, color: "var(--text-dark)" }, 0)
      .to(image, { duration: 1.1, scale: 1.2 }, 0);
    // .to(cursor, { duration: 0.3, borderColor: "#191919" }, 0);
  }

  return tl;
}

function getTextHeight(textCopy) {
  return textCopy.clientHeight;
}
